import { render, staticRenderFns } from "./setSetinfor.vue?vue&type=template&id=26d57140&scoped=true"
import script from "./setSetinfor.vue?vue&type=script&lang=js"
export * from "./setSetinfor.vue?vue&type=script&lang=js"
import style0 from "./setSetinfor.vue?vue&type=style&index=0&id=26d57140&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d57140",
  null
  
)

export default component.exports